module.exports = __webpack_public_path__ + "static/favicon-74a29abe7658356a82bae79a4e62c4c4.png";